import { Col, Row, Tooltip } from 'antd';
import React, { useLayoutEffect, useMemo, useState } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../../../../api';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { RootState } from '../../../../../store/rootReducer';
import HSButton from '../../../../common/Button';
import HSDropdown from '../../../../common/Dropdown';
import NormalInput from '../../../../common/NormalInput';
import LoginActions from '../../../../login/redux/actions';
import MessageActions from '../../../../message/redux/actions';
import { ONBOARDING_PATH } from '../../Onbording';
import OnboardingCard from '../common/Card';
import OnboardingRightContainer from '../common/Container';
import NotificationBanner from '../common/NotificationBanner';
import ProfileConfirmation from './ProfileConfirmation';

type InvestorProfileProps = {
    isSetting?: boolean;
    onClickCancel?: () => void;
};

const InvestorProfile: React.FC<InvestorProfileProps> = ({ isSetting, onClickCancel }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const isTeamMember: boolean = useIsTeamMember();

    const type = useSelector((state: RootState) => state.user.investor?.investorType);
    const investorUUID = useSelector((state: RootState) => state.user.uuid);
    const investor = useSelector((state: RootState) => state.user.investor);
    const profile = useSelector((state: RootState) => state.user.investor?.profile);
    // const teamListLoading = useSelector((state: RootState) => state.teamManagement.loading);
    // const teamName = useSelector((state: RootState) => state.user.investor?.team?.teamName);

    const [formFields, setFormFields] = useState<FormField>({
        companyName: undefined,
        website: undefined,
        jobTitle: undefined,
        investmentExperience: undefined,
        status: undefined,
        isValidate: false,
        institutionalType: undefined,
        countryOfIncorporation: undefined,
        authorityRegulatedBy: undefined,
        isTeam: 'No',
        teamEmails: [],
    });

    const [loading, setLoading] = useState(false);
    // const [teamLoading, setTeamLoading] = useState(false);
    const [isShowConfirmation, setConfirmation] = useState(false);

    useLayoutEffect(() => {
        if (profile) {
            setFormFields({
                companyName: profile.companyName,
                website: profile.companyWebsite,
                jobTitle: profile.jobTitle,
                investmentExperience: profile.investmentExperience,
                status: profile.employmentStatus,
                isValidate: false,
                institutionalType: profile.institutionType,
                isTeam: 'No',
                teamEmails: [],
                countryOfIncorporation: profile.countryOfIncorporation,
                authorityRegulatedBy: profile.authorityRegulatedBy,
            });
        }
        return () => {
            setFormFields({
                companyName: undefined,
                website: undefined,
                jobTitle: undefined,
                investmentExperience: undefined,
                status: undefined,
                isValidate: false,
                countryOfIncorporation: undefined,
                institutionalType: undefined,
                isTeam: 'No',
                teamEmails: [],
                authorityRegulatedBy: undefined,
            });
        };
    }, [profile]);

    // useEffect(() => {
    //     if (investorUUID && teamName) {
    //         dispatch(TeamManagementActions.fetchTeamMembers(investorUUID));
    //     }
    // }, [dispatch, teamName, investorUUID]);

    // const inviteTeamMember = (investorUUID: string, teamList: string[]) => {
    //     setTeamLoading(true);
    //     const inviteEmails = teamList.map((e) => {
    //         return { email: e };
    //     });
    //     Apis.inviteTeamMember(investorUUID, inviteEmails)
    //         .then(({ data }) => {
    //             if (data) {
    //                 setConfirmation(true);
    //                 dispatch(TeamManagementActions.fetchTeamMembers(investorUUID));
    //             }
    //         })
    //         .catch((err) => {
    //             dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
    //         })
    //         .finally(() => {
    //             setTeamLoading(false);
    //         });
    // };

    const onClickOnNext = () => {
        // if (isTeamMember || isShowConfirmation) {
        //     return navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.NDA}`);
        // }
        let obj: any = {};

        setFormFields({ ...formFields, isValidate: true });

        const {
            companyName,
            status,
            investmentExperience,
            jobTitle,
            countryOfIncorporation,
            institutionalType,
            website,
            authorityRegulatedBy,
        } = formFields;

        if (type === 'Individual Accredited') {
            if (!status || !investmentExperience) {
                return;
            }
            obj = {
                companyName,
                employmentStatus: status,
                jobTitle,
                investmentExperience,
            };
        } else if (type === 'Institutional' || type === 'Corporate Accredited') {
            if (!companyName?.trim() || !countryOfIncorporation?.trim()) {
                return;
            }
            obj = {
                institutionType: institutionalType,
                companyName: companyName.trim(),
                companyWebsite: website,
                countryOfIncorporation: countryOfIncorporation.trim(),
            };
            if (type === 'Institutional' && !authorityRegulatedBy) {
                return;
            }
            if (type === 'Institutional') {
                obj.authorityRegulatedBy = authorityRegulatedBy;
            }
        }
        setFormFields({ ...formFields, isValidate: false });
        if (investorUUID) {
            setLoading(true);
            Apis.updateInvestorProfile(investorUUID, obj)
                .then(({ data }) => {
                    dispatch(LoginActions.updateInvestorInfo(data));
                    navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.NDA}`);
                    // if (
                    //     (formFields.isTeam === 'Yes' && formFields?.teamEmails.length) ||
                    //     (teamName && formFields?.teamEmails.length)
                    // ) {
                    //     if (!teamName || teamName === '') {
                    //         Apis.createTeam(investorUUID)
                    //             .then(({ data }) => {
                    //                 if (data) {
                    //                     inviteTeamMember(investorUUID, formFields?.teamEmails || []);
                    //                     dispatch(LoginActions.updateInvestorInfo(data));
                    //                 }
                    //             })
                    //             .catch((err) => {
                    //                 dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                    //             });
                    //     } else {
                    //         inviteTeamMember(investorUUID, formFields?.teamEmails || []);
                    //     }
                    // } else {

                    // }
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setLoading(false);
                    if (onClickCancel) {
                        onClickCancel();
                    }
                });
        }
    };

    const isShowNotification = useMemo(() => {
        const NDA = investor?.agreements?.find((a) => a.agreementType === 'NDA');
        if (investor?.investorType === 'Individual Accredited') {
            if (NDA?.lastAudit.at) {
                if (!investor.profile?.employmentStatus) {
                    return true;
                }
            }
        }

        if (investor?.investorType === 'Institutional') {
            if (NDA?.lastAudit.at) {
                if (!investor.profile?.companyName) {
                    return true;
                }
            }
        }

        if (investor?.investorType === 'Corporate Accredited') {
            if (NDA?.lastAudit.at) {
                if (!investor.profile?.companyName) {
                    return true;
                }
            }
        }

        return false;
    }, [investor]);

    const formUI = useMemo(() => {
        switch (type) {
            case 'Individual Accredited':
                return (
                    <IndividualProfile
                        formFields={formFields}
                        setFormFields={setFormFields}
                        // isTeamMember={isTeamMember}
                    />
                );
            case 'Corporate Accredited':
            case 'Institutional':
                return (
                    <InstitutionalProfile
                        formFields={formFields}
                        setFormFields={setFormFields}
                        // teamName={teamName}
                        // isTeamMember={isTeamMember}
                        investorType={type}
                    />
                );
            default:
                return null;
        }
    }, [type, formFields]);

    return (
        <OnboardingRightContainer>
            <div>
                {isShowNotification && (
                    <div className="my-3">
                        <NotificationBanner desc="To provide you with the best investment experience, we would like to know a bit more about you. This should not take over 5 minutes." />
                    </div>
                )}
                {isShowConfirmation ? <ProfileConfirmation setConfirmation={setConfirmation} /> : formUI}

                <div className="flex justify-center items-center mt-10 mb-5">
                    <HSButton
                        title={isSetting ? 'Update' : 'Next'}
                        type="primary"
                        onClick={onClickOnNext}
                        // disabled={teamListLoading}
                        loading={loading}
                    />
                    {isSetting && onClickCancel && (
                        <HSButton title={'Cancel'} className="onboarding_btn ml-2" onClick={onClickCancel} light />
                    )}
                </div>
            </div>
        </OnboardingRightContainer>
    );
};

export default InvestorProfile;

const empStatus = ['Employed', 'Self-Employed', 'Retired', 'Unemployed'];
const InvestmentExperience = [
    'I have experience in private market investments',
    'I have NO experience in private market investments',
];

type IndividualProps = {
    formFields: FormField;
    setFormFields: (f: FormField) => void;
    // isTeamMember: boolean;
};
const IndividualProfile: React.FC<IndividualProps> = ({ formFields, setFormFields }) => {
    const form = useMemo(() => {
        const onFieldChange = (data: { name: string; value?: number | string }) => {
            const { name, value } = data;
            let obj = { ...formFields };
            if (name) {
                obj[name] = (value as string) || '';
            }
            setFormFields(obj);
        };
        return (
            <>
                <Row gutter={[16, 16]} className="pt-6">
                    <Col xs={24} md={12}>
                        <NormalInput
                            name="companyName"
                            title="Company Name"
                            value={formFields.companyName}
                            onChange={onFieldChange}
                            className="rounded-xl"
                            // disabled={isTeamMember}
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <NormalInput
                            name="jobTitle"
                            title="Job Title"
                            value={formFields.jobTitle}
                            onChange={onFieldChange}
                            className="rounded-xl"
                            // disabled={isTeamMember}
                        />
                    </Col>
                </Row>
            </>
        );
    }, [formFields, setFormFields]);
    return (
        <div>
            <p className="page_title_onboarding pt-0">
                Choose your Employment Status <span className="text-red-500">*</span>
            </p>
            <div className="py-4">
                <Row gutter={[16, 16]}>
                    {empStatus.map((s, index) => (
                        <Col xs={12} md={12} lg={8} xl={6} xxl={6} key={`${s}_${index}`}>
                            <OnboardingCard
                                onClick={() => {
                                    let name = 'status';
                                    setFormFields({ ...formFields, [name]: s });
                                }}
                                selected={formFields.status === s}
                                className="text-center justify-center items-center"
                                style={{ minHeight: '4rem', fontSize: 14, marginBottom: 0 }}
                            >
                                {s}
                            </OnboardingCard>
                        </Col>
                    ))}
                </Row>
                {formFields.isValidate && !formFields.status && (
                    <div className="common_error relative top-2">Please select status</div>
                )}
            </div>
            {form}
            <div>
                <p className="page_title_onboarding pt-6 pb-4">
                    What is your Investment Experience? <span className="text-red-500">*</span>
                </p>
                {InvestmentExperience.map((l, index) => (
                    <OnboardingCard
                        key={`${l}_${index}`}
                        onClick={() => {
                            // if (!isTeamMember) {
                            let name = 'investmentExperience';
                            setFormFields({ ...formFields, [name]: l });
                            // }
                        }}
                        selected={formFields.investmentExperience === l}
                    >
                        {l}
                    </OnboardingCard>
                ))}
                {formFields.isValidate && !formFields.investmentExperience && (
                    <div className="common_error relative -top-4">Please select investment experience</div>
                )}
            </div>
        </div>
    );
};

type InstitutionalProps = {
    formFields: FormField;
    setFormFields: (f: FormField) => void;
    // teamName?: string;
    // isTeamMember: boolean;
    investorType: string;
};
// const typeOfInstitution = [
//     'Corporate Business',
//     'Corporate VC / PE',
//     'Family Office / Multi Family Office',
//     'VC / PE',
//     'Fund of Funds',
//     'Sovereign',
//     'DFI',
//     'Asset Manager',
//     'Other',
// ];
const InstitutionalProfile: React.FC<InstitutionalProps> = ({
    formFields,
    setFormFields,
    // teamName,
    // isTeamMember,
    investorType,
}) => {
    const DialCodes = useSelector((state: RootState) => state.constants.constants.countries);

    //const teamList = useSelector((state: RootState) => state.teamManagement.teamMemberList);
    //const loading: boolean = useSelector((state: RootState) => state.teamManagement.loading);

    const form = useMemo(() => {
        const onFieldChange = (data: { name: string; value?: number | string }) => {
            const { name, value } = data;
            let obj = { ...formFields };
            if (name) {
                obj[name] = (value as string) || '';
            }
            setFormFields(obj);
        };

        // const onChangeTeamRadio = (e: RadioChangeEvent) => {
        //     let obj = { ...formFields };
        //     let name = 'isTeam';
        //     if (name) {
        //         obj[name] = e.target.value;
        //     }
        //     setFormFields(obj);
        // };

        return (
            <>
                <Row gutter={[16, 16]} className="pt-4">
                    <Col xs={24} md={12}>
                        <NormalInput
                            name="companyName"
                            title="Legal Entity Name"
                            value={formFields.companyName}
                            onChange={onFieldChange}
                            className="rounded-xl"
                            isRequired
                            // disabled={isTeamMember}
                        />
                        {formFields.isValidate && (!formFields.companyName || formFields.companyName.trim() === '') && (
                            <span className="common_error">Please enter legal name.</span>
                        )}
                    </Col>
                    <Col xs={24} md={12}>
                        <HSDropdown
                            label="Country of Incorporation"
                            required
                            value={formFields.countryOfIncorporation}
                            name="countryOfIncorporation"
                            onChange={onFieldChange}
                            placeholder="Enter Country of Incorporation"
                            options={(DialCodes || []).map((c) => {
                                return { label: c.name, value: c.name };
                            })}
                            // disabled={isTeamMember}
                        />
                        {formFields.isValidate &&
                            (!formFields.countryOfIncorporation || formFields.countryOfIncorporation.trim() === '') && (
                                <span className="common_error">Please enter country of incorporation.</span>
                            )}
                    </Col>
                    {investorType === 'Institutional' ? (
                        <Col xs={24} md={12} className="relative">
                            <NormalInput
                                name="authorityRegulatedBy"
                                title="Authority Regulated By/Government-Owned Entity"
                                value={formFields.authorityRegulatedBy}
                                onChange={onFieldChange}
                                className="rounded-xl"
                                // disabled={isTeamMember}
                                isRequired={true}
                            />
                            <Tooltip
                                title={
                                    <div className="text-center WorkSans">
                                        Please indicate which authority you are regulated by or indicate if you are a
                                        government-owned entity, specifying which government you are owned by
                                    </div>
                                }
                            >
                                <div className=" absolute right-2 top-0">
                                    <AiOutlineInfoCircle color="#26AE60" size={'1.3rem'} className="inline" />{' '}
                                </div>
                            </Tooltip>
                            {formFields.isValidate &&
                                (!formFields.authorityRegulatedBy || formFields.authorityRegulatedBy.trim() === '') && (
                                    <span className="common_error">
                                        Please enter Authority Regulated By/Government-Owned Entity.
                                    </span>
                                )}
                        </Col>
                    ) : null}
                    <Col xs={24} md={12}>
                        <NormalInput
                            name="website"
                            title="Company Website"
                            value={formFields.website}
                            onChange={onFieldChange}
                            className="rounded-xl"
                            // disabled={isTeamMember}
                        />
                    </Col>
                    {/* <Col xs={24}>
                        {!teamName ? (
                            <>
                                <p className="text-[#20222B] font-[WorkSans-Semibold] font-semibold text-sm mb-1 mt-4">
                                    Would you like to create a team account?
                                </p>
                                <Radio.Group
                                    size="large"
                                    className="radio_custome"
                                    onChange={onChangeTeamRadio}
                                    value={formFields.isTeam}
                                    disabled={isTeamMember}
                                >
                                    <Radio value={'Yes'}>Yes</Radio>
                                    <Radio value={'No'}>No</Radio>
                                </Radio.Group>
                            </>
                        ) : null}

                        {(formFields.isTeam === 'Yes' && !isTeamMember) || (teamName && !isTeamMember) ? (
                            <div className="py-3">
                                <p className="text-[#20222B] WorkSans text-sm">
                                    Please enter the email addresses of team members that you would like to add to your
                                    team
                                </p>
                                <div className="common_selection">
                                    <Select
                                        mode={'tags'}
                                        className={`appearance-none  rounded w-full  text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1 `}
                                        placeholder="Enter email id and click enter"
                                        optionFilterProp="children"
                                        onChange={(data) => {
                                            setFormFields({ ...formFields, teamEmails: data });
                                        }}
                                        options={[]}
                                        open={false}
                                        value={formFields.teamEmails}
                                        tagRender={DropdownTags}
                                        onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                // You can add custom logic here if needed
                                            }
                                        }}
                                        disabled={isTeamMember}
                                    />
                                </div>
                            </div>
                        ) : null}

                        {!isTeamMember ? (
                            <p className="text-[#20222B] italic text-sm mt-2 !font-[Lato]">
                                Note: The account associated with your email address will have admin controls. This can
                                be changed later on.
                            </p>
                        ) : null}
                    </Col> */}
                    {/* {loading ? (
                        <div className="w-full flex item-center justify-center">
                            {' '}
                            <Loader />
                        </div>
                    ) : teamName ? (
                        <ExistingTeamMember
                            existingTeamMemberList={teamList.members}
                            title="Existing Team Members"
                            showAction={false}
                            showTitle={true}
                        />
                    ) : null} */}
                </Row>
            </>
        );
    }, [formFields, setFormFields, DialCodes, investorType]);

    return <div>{form}</div>;
};

interface FormField {
    [k: string]: string | boolean | undefined | string[];
    companyName?: string;
    jobTitle?: string;
    website?: string;
    investmentExperience?: string;
    status?: string;
    institutionalType?: string;
    isValidate: boolean;
    countryOfIncorporation?: string;
    isTeam: string;
    teamEmails: string[];
    authorityRegulatedBy?: string;
}
